import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';

import { IS_EDITOR_MODE } from 'config/envVariable';
import { langTypes } from 'config/langType';

// Dynamic imports for new file structure
const loadTranslations = async () => {
    const availableLanguages = ['zh-TW', 'en-US', 'zh-CN', 'ja', 'th', 'es-419', 'pt-BR'];
    const resources = {};
    const folder = IS_EDITOR_MODE ? 'editor' : 'client';

    const loadPromises = availableLanguages.map(async lang => {
        try {
            const translation = await import(`./${folder}/${lang}.json`);
            return { lang, translation: translation.default };
        } catch (error) {
            console.warn(`Failed to load translation for ${lang}:`, error);
            return { lang, translation: null };
        }
    });
    const results = await Promise.all(loadPromises);

    results.forEach(({ lang, translation }) => {
        if (translation) {
            resources[lang] = { translation };
        }
    });

    return resources;
};

const initLang = navigator.language || langTypes.EN_US;

i18n.use(ICU)
    .use(initReactI18next)
    .init({
        resources: {},
        lng: initLang,
        fallbackLng: langTypes.ZH_TW,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export let i18nLangOfGame = null;

if (IS_EDITOR_MODE) {
    i18nLangOfGame = i18n.createInstance();
    i18nLangOfGame.use(ICU).init({
        resources: {},
        lng: langTypes.ZH_TW,
        fallbackLng: {
            [langTypes.ZH_TW]: [langTypes.ZH_TW, langTypes.EN_US],
            [langTypes.ZH_CN]: [langTypes.ZH_TW, langTypes.EN_US],
            [langTypes.JA_JP]: [langTypes.EN_US, langTypes.ZH_TW],
            [langTypes.ES_419]: [langTypes.EN_US, langTypes.ZH_TW],
            [langTypes.PT_BR]: [langTypes.EN_US, langTypes.ZH_TW],
            [langTypes.EN_US]: [langTypes.EN_US, langTypes.ZH_TW],
            default: [langTypes.ZH_TW, langTypes.EN_US]
        },
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
    });
}

// Load translations asynchronously
loadTranslations()
    .then(resources => {
        // Add resources to main i18n instance
        Object.keys(resources).forEach(lang => {
            i18n.addResourceBundle(lang, 'translation', resources[lang].translation);
        });

        // Add resources to editor game instance if it exists
        if (i18nLangOfGame && IS_EDITOR_MODE) {
            Object.keys(resources).forEach(lang => {
                i18nLangOfGame.addResourceBundle(lang, 'translation', resources[lang].translation);
            });
        }
    })
    .catch(error => {
        console.error('Failed to load translations:', error);
    });

export function setI18nLanguage({ lang, editorGameLang } = {}) {
    let promises = [];
    if (lang !== undefined) {
        promises.push(new Promise(res => i18n.changeLanguage(lang, () => res())));
    }
    if (editorGameLang !== undefined && IS_EDITOR_MODE) {
        promises.push(
            new Promise(res => i18nLangOfGame.changeLanguage(editorGameLang, () => res()))
        );
    }
    return Promise.all(promises);
}

export default i18n;
